<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">District</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36px" height="36px" style="margin-left: 0.5em;" src="assets/tenant-avatar.jpg" class="rounded-circle" />
          </div>
        </div>

        <!-- Search + Add on same line -->
        <div class="row my-4 align-items-center">
          <!-- Search wrapper -->
          <div class="col-md-4">
            <div class="search-wrapper">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>

              <input
                type="text"
                class="search-input"
                placeholder="District"
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
                aria-label="Search"
              />

              <button
                *ngIf="searchval"
                class="clear-btn"
                type="button"
                (click)="reset()"
                aria-label="Clear search"
              >
                ✕
              </button>
            </div>
          </div>

          <!-- optional spacer -->
          <div class="col-md-4"></div>

          <!-- Add District button aligned right -->
          <div class="col-md-4 text-right">
            <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add District
            </button>
          </div>
        </div>

        <!-- Cards / Grid -->
        <div class="row" *ngIf="showData">
          <div class="col-md-3 degreeContent" *ngFor="let district of districtValue">
            <p style="text-align:left;">
              {{ district.district }}
              <i class="fa fa-trash-o iconEdit" (click)="deleteCountry(district)" aria-hidden="true"></i>
            </p>
          </div>
        </div>

        <!-- No Data -->
        <div class="noData" *ngIf="showNodata">
          <h2>Currenly No Data Available!</h2>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <div class="backdrop" [ngStyle]="{'display':display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add District
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-header" *ngIf="showEdit">
              Edit District
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="districtForm">
                <label>District</label>
                <input type="text" class="form-control" formControlName="districtName" [(ngModel)]="district" />
                <div class="error-messages">
                  <div *ngFor="let error of error_messages.districtName">
                    <div class="error-message" *ngIf="districtForm.get('districtName').hasError(error.type) && (districtForm.get('districtName').dirty || districtForm.get('districtName').touched)">
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <div class="addBtn" *ngIf="showAdd">
                  <button class="commonBtn mt-2" [disabled]="!districtForm.valid" (click)="addDistrict()">Add District</button>
                </div>
                <div class="addBtn" *ngIf="showEdit">
                  <button class="commonBtn mt-2" [disabled]="!districtForm.valid" (click)="updateDistrict()">Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
      <div class="modal" id="deleteModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
              <p>Do you want to delete Degree ?</p>
              <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
              <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
              <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
